/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/destructuring-assignment */
import { Alert, Button, Group, Paper, Space, Text, ThemeIcon } from '@mantine/core';
import {
  IconCalendarEvent,
  IconCertificate,
  IconCircleX,
  IconDeviceFloppy,
  IconId,
  IconSchema,
} from '@tabler/icons-react';
import { Tabs } from 'antd';
import { useMemo, useRef, useState } from 'react';
import RecurrenceForm from '../../../../../../../components/core/Recurrence/RecurrenceForm';
import { ProposalGeneralData } from '../../../../../../../contexts/core/proposals/ProposalGeneral.context';
import {
  EntityTypeType,
  ResidueStateOfMatterType,
  UnitOfMeasureType,
} from '../../../../../../../models/core/cache.type';
import { Action } from '../../../../../../../models/core/core.type';
import {
  ProposalResiduePlanQuotationType,
  ProposalResiduePlanType,
  ProposalResidueType,
  ProposalServiceType,
} from '../../../../../../../models/core/proposals.type';
import { Feature } from '../../../../../../../utils/constants.utils';
import { newGuid } from '../../../../../../../utils/helper.utils';
import ResidueDocumentFormView from './components/ResidueDocumentFormView';
import ResidueGeneralFormView from './components/ResidueGeneralFormView';
import ResiduePlanSummaryEditor from './components/ResiduePlanSummaryEditor';

type ProposalFormViewProps = {
  referenceData: {
    unitOfMeasures: UnitOfMeasureType[];
    entityTypeData: EntityTypeType[];
    residueStateOfMatterType: ResidueStateOfMatterType[];
  };
  proposalGeneralData: ProposalGeneralData;
  origItem: ProposalResidueType | null;
  item: ProposalResidueType | null;
  idProposta: number | undefined;
  services: ProposalServiceType[];
  defaultActiveKey?: string;
  initialPlanItem?: ProposalResiduePlanType | null;
  initialQuotationItem?: ProposalResiduePlanQuotationType | null;
  initialPlanTab?: string;
  autoOpenPlanModal?: boolean;
  initialPlanGeneralTab?: string;
  initialPlanGeneralItemId?: string | number | null;
  initialPlanGeneralItemAction?: 'add' | 'open';
  initialQuotationTab?: string;
  initialQuotationChildItemId?: string | number | null;
  initialQuotationChildTab?: string;
  autoOpenQuotationModal?: boolean;

  callback(item: ProposalResidueType | null, action: string, confirmed: boolean): void;
  zIndex: number;
};

export default function ResidueFormAddEdit(props: ProposalFormViewProps) {
  const disabled = false; // !!props.item?.idPropostaResiduoPai;

  const [error, setError] = useState<any | null>(null);
  const [plansData, setPlansData] = useState<ProposalResiduePlanType[]>(
    props.item?.planos.map((plan) => ({
      ...plan,
      action: plan.action || Action.Nothing,
      id: plan.id || plan.idPropostaResiduoPlano?.toString() || plan.idTemporaria || newGuid(),
    })) || []
  );

  const refGeneralForm = useRef<any>();
  const refDocumentForm = useRef<any>();
  const refRecurrenceForm = useRef<any>();

  const currentResidueData = useMemo<ProposalResidueType>(
    () =>
      ({
        ...(props.item || ({} as ProposalResidueType)),
        planos: plansData,
      } as ProposalResidueType),
    [plansData, props.item]
  );

  const tabs = [
    {
      key: 'Geral',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconId size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Geral
          </Text>
        </Group>
      ),
      children: (
        <ResidueGeneralFormView
          ref={refGeneralForm}
          proposalGeneralData={props.proposalGeneralData}
          callback={props.callback}
          idProposta={props.idProposta}
          item={props.item}
          origItem={props.origItem}
          referenceData={props.referenceData}
          disabled={disabled}
          zIndex={props.zIndex + 1}
        />
      ),
      forceRender: true,
    },
    {
      key: 'Documentos',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconCertificate size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Documentos
          </Text>
        </Group>
      ),
      children: (
        <Paper shadow="xs" p="md" withBorder>
          <ResidueDocumentFormView ref={refDocumentForm} proposalResidue={props.item} />
        </Paper>
      ),
      forceRender: true,
    },
    {
      key: 'Recorrencia',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconCalendarEvent size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Recorrência
          </Text>
        </Group>
      ),
      children: (
        <RecurrenceForm
          idPropostaRecorrencia={props.item?.recorrencia.idPropostaRecorrencia || null}
          title="Recorrência"
          description="Eventos personalizados a serem gerados para este resíduo."
          color={Feature.Home.Proposal.color}
          minDate={props.proposalGeneralData.dataInicial}
          maxDate={props.proposalGeneralData.dataFinal}
          ref={refRecurrenceForm}
          dataInicial={props.item?.recorrencia.dataInicial || props.proposalGeneralData.dataInicial}
          dataFinal={props.item?.recorrencia.dataFinal || props.proposalGeneralData.dataFinal}
          quantidade={props.item?.recorrencia.quantidade || null}
          cada={props.item?.recorrencia.cada || null}
          frequencia={props.item?.recorrencia.frequencia || null}
          ocorrencia={props.item?.recorrencia.ocorrencia || null}
          diasSemana={props.item?.recorrencia.diasSemana || null}
          diasMes={props.item?.recorrencia.diasMes || null}
          mesAno={props.item?.recorrencia.mesAno || null}
          disabled={false}
          zIndex={props.zIndex + 1}
        />
      ),
      forceRender: true,
    },
    {
      key: 'Planos',
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconSchema size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Planos
          </Text>
        </Group>
      ),
      children: (
        <Paper shadow="xs" p="md" withBorder>
          <ResiduePlanSummaryEditor
            data={currentResidueData}
            isEdit
            referenceData={{
              unitOfMeasures: props.referenceData.unitOfMeasures,
              entityTypeData: props.referenceData.entityTypeData,
            }}
            services={props.services}
            zIndex={props.zIndex + 1}
            onChange={(nextResidue) => setPlansData(nextResidue.planos)}
          />
        </Paper>
      ),
      forceRender: true,
    },
  ];

  const handleSubmit = (action = 'callback') => {
    let step = 'Geral';
    try {
      const generalData = refGeneralForm.current.validate();

      step = 'Documentos';
      const documento = refDocumentForm.current.validate();

      step = 'Recorrência';
      const recorrenciaData = refRecurrenceForm?.current?.validate();
      recorrenciaData.idPropostaRecorrencia = props.origItem?.recorrencia.idPropostaRecorrencia;
      recorrenciaData.idProposta = props.origItem?.recorrencia.idProposta;
      recorrenciaData.idPropostaResiduo = props.origItem?.recorrencia.idPropostaResiduo;

      step = 'Planos';
      const planosData = plansData;

      props.callback(
        {
          ...generalData,
          documento,
          recorrencia: recorrenciaData,
          planos: planosData,
        },
        action,
        true
      );
    } catch (ex: any) {
      setError({
        title: step,
        message: ex.message,
      });
    }
  };

  return (
    <div>
      <Paper shadow="xs" p="md" withBorder>
        {error && (
          <>
            <Alert
              icon={<IconCircleX size={18} />}
              title={error.title}
              color="red"
              withCloseButton
              onClose={() => setError(null)}
            >
              {error.message}
            </Alert>
            <Space h="xl" />
          </>
        )}

        <Tabs items={tabs} defaultActiveKey={props.defaultActiveKey || 'Geral'} />
      </Paper>
      <Space h="lg" />

      <Group justify="right">
        <Button leftSection={<IconDeviceFloppy size={18} />} onClick={() => handleSubmit()}>
          Salvar
        </Button>
      </Group>
    </div>
  );
}
